import { inject, observer } from "mobx-react";

import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";

import { useState, useEffect } from "react";

import "./style.scss";
import { Tag } from "primereact/tag";
import { getStatusTag } from "../../../../helpers/utils";
import ButtonUI from "@UI/ButtonUI";

const defaultRatesArray = {
    counts: null,
    ratesId: null,
};

const ActivateFlexible = inject("mainStore")(
    observer(({ mainStore, vendors, rates, offer, sites, tabItems, forceSet }) => {
        const [data, setData] = useState({ offerId: null, dateStart: null, dateEnd: null, ratesArray: [], siteId: null, vendorId: null });
        const [ratesVendor, setRatesVendor] = useState([]);
        const [disabledSave, setDisabledSave] = useState(true);
        const date = new Date(Date.now() - 24 * 60 * 60 * 1000);

        const offerFilter = data.vendorId
            ? (() => {
                  const { active, inactive } = offer.reduce(
                      (acc, item) => {
                          if (item.vendorId === data.vendorId._id && !item.draft) {
                              acc[item.active ? "active" : "inactive"].push(item);
                          }
                          return acc;
                      },
                      { active: [], inactive: [] },
                  );
                  return [...active.sort((a, b) => new Date(a.dateStart) - new Date(b.dateStart)), ...inactive.sort((a, b) => (a.dateEnd ? new Date(a.dateEnd) : Infinity) - (b.dateEnd ? new Date(b.dateEnd) : Infinity))];
              })()
            : offer;

        const ratesFilter = ratesVendor && ratesVendor.length ? rates.filter((el) => ratesVendor.includes(el._id) && !el.archived && data?.offerId?.rateIds.includes(el._id)) : [];

        useEffect(() => {
            const val = validKeys(data.ratesArray, validRates) || false;
            setDisabledSave(val);
        }, [data]);

        const handleChange = (item, index, value, type) => {
            const newRates = data.ratesArray;
            newRates[index] = { ...item, [type]: value };
            setData((prev) => {
                return { ...prev, ratesArray: newRates };
            });
        };

        const countryTemplate = (option) => {
            const type = tabItems.find((i) => i.key === option.cpoType);
            return (
                <div className="multi__item">
                    <div className={`item__label ${option.cpoType === "percentAmount" ? "yellow" : option.cpoType === "rateGradation" ? "blue" : ""}`}>{type.label}</div>
                    {option.cpoType === "rateGradation" ? null : <div>{option.rate}</div>}
                    <div>{option.comments}</div>
                </div>
            );
        };

        const selectTemp = (option) => {
            if (option) {
                const typeLabel = tabItems.find((i) => i.key === option.cpoType)?.label || "";
                return (
                    <div className="multi__item">
                        <div className={`item__label ${option.cpoType === "percentAmount" ? "yellow" : option.cpoType === "rateGradation" ? "blue" : ""}`}>{typeLabel}</div>
                        {option.cpoType === "rateGradation" ? null : <div>{option.rate}</div>}
                        <div>{option.comments}</div>
                    </div>
                );
            } else {
                return <div>Укажите ставку</div>;
            }
        };

        const countryOptionTemplate = (option) => {
            const tag = getStatusTag(option);
            return (
                <div className={`item__dropdown`}>
                    <div style={{ fontWeight: "600" }}>{option.title}</div>
                    <div style={{ fontSize: "12px" }}>({option.code})</div>
                    <Tag severity={tag.type} icon={tag.icon} />
                </div>
            );
        };

        const handleBtn = async () => {
            const obj = {
                type: "flexibleActivations",
                // siteId: data.siteId ? data.siteId._id : null,
                offerId: data.offerId._id,
                dateEnd: data.dateEnd ? moment(data.dateEnd).format("DD.MM.YYYY") : null,
                dateStart: data.dateStart ? moment(data.dateStart).format("DD.MM.YYYY") : null,
                ratesArray: data.ratesArray,
                activationCounts: Math.max(...data.ratesArray.map((i) => i.counts)),
                forceSet: forceSet,
            };

            const resp = await mainStore.postByUrl("/promo/upload_activatios_by_type", obj);

            if (resp && resp.success) {
                mainStore.setMainStore("toast", { severity: "success", summary: `Загрузка прошла успешно` });
                setData({ offerId: null, dateStart: null, dateEnd: null, ratesArray: [], siteId: null, vendorId: null });
                mainStore.setMainStore("activate", {});
            }
        };

        return (
            <div className="activate__flexible">
                <div className="wrapper">
                    <label className="label">Вендора</label>
                    <Dropdown
                        value={data.vendorId}
                        onChange={(e) => {
                            setRatesVendor(e.value.rateIds);
                            setData((prev) => {
                                return { ...prev, vendorId: e.value };
                            });
                        }}
                        options={vendors ? vendors : []}
                        optionLabel="name"
                        placeholder="Выберите из списка"
                        className="dropdown"
                        filter
                        virtualScrollerOptions={{ itemSize: 38 }}
                    />
                </div>

                <div className="wrapper">
                    <label className="label">Оффер</label>
                    <Dropdown
                        value={data.offerId}
                        onChange={(e) => {
                            setData((prev) => {
                                return { ...prev, offerId: e.value };
                            });
                        }}
                        options={offerFilter ? offerFilter : []}
                        optionLabel="title"
                        placeholder="Выберите из списка"
                        className="dropdown"
                        disabled={!data.vendorId}
                        filter
                        itemTemplate={countryOptionTemplate}
                        // virtualScrollerOptions={{ itemSize: 48 }}
                    />
                </div>

                <div className="date__block">
                    <label className="label">Укажите диапазон активаций</label>
                    <div className="input__block">
                        <div className="input__block item">
                            <Calendar
                                value={data.dateStart}
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, dateStart: e.value };
                                    })
                                }
                                dateFormat="С dd.mm.yy"
                                placeholder="Укажите диапазон активаций"
                                locale="rus"
                                maxDate={date}
                            />
                            <i className="pi pi-calendar"></i>
                        </div>

                        <div className="input__block item">
                            <Calendar
                                value={data.dateEnd}
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, dateEnd: e.value };
                                    })
                                }
                                dateFormat="По dd.mm.yy"
                                placeholder="Укажите диапазон активаций"
                                locale="rus"
                                minDate={data.dateStart}
                                maxDate={date}
                            />
                            <i className="pi pi-calendar"></i>
                        </div>
                    </div>
                </div>
                {data.ratesArray.map((item, idx) => (
                    <div className="block" key={idx}>
                        <div className="wrapper">
                            <label className="label">Введите количество активаций</label>
                            <InputNumber value={item.counts} onValueChange={(e) => handleChange(item, idx, e.value, "counts")} style={{ width: "100%" }} placeholder="100 000 000" />
                        </div>

                        <div className="switch">
                            <InputSwitch checked={item.customRates} onChange={(e) => handleChange(item, idx, e.value, "customRates")} />
                            <label className="switch__label">Кастомная ставка</label>
                        </div>
                        {!item.customRates ? (
                            <div className="radio__block">
                                <label className="label">Укажите ставку</label>
                                <Dropdown
                                    value={item.ratesId}
                                    onChange={(e) => handleChange(item, idx, e.value, "ratesId")}
                                    options={ratesFilter ? ratesFilter : []}
                                    placeholder="Укажите ставку"
                                    className="dropdown"
                                    valueTemplate={selectTemp}
                                    itemTemplate={countryTemplate}
                                    disabled={!data.offerId}
                                    optionValue="_id"
                                />
                            </div>
                        ) : (
                            <div className="wrapper">
                                <label className="label">Укажите кастомную ставку (с НДС)</label>
                                <InputNumber value={item.priceWithNds} onValueChange={(e) => handleChange(item, idx, e.value, "priceWithNds")} style={{ width: "100%" }} placeholder="Введите ставку" locale="ru-RU" mode="currency" currency="RUB" />
                            </div>
                        )}

                        {item.isRevenue ? (
                            <div className="row">
                                <InputNumber value={item.revenue} onValueChange={(e) => handleChange(item, idx, e.value, "revenue")} style={{ width: "100%" }} locale="ru-RU" mode="currency" currency="RUB" placeholder="100 000 000" />

                                <div className="switch">
                                    <InputSwitch checked={item.isTotalRevenue} onChange={(e) => handleChange(item, idx, e.value, "isTotalRevenue")} />
                                    <label className="switch__label">Общая </label>
                                </div>
                            </div>
                        ) : null}
                    </div>
                ))}

                <ButtonUI
                    label="Добавить ставку"
                    icon="pi pi-plus"
                    outlined
                    onClick={() =>
                        setData((prev) => {
                            return { ...prev, ratesArray: prev.ratesArray.concat(defaultRatesArray) };
                        })
                    }
                    disabled={!(data.dateEnd && data.dateStart && data.vendorId && data.offerId)}
                />

                <div className="activate__flexible_btn">
                    <ButtonUI label="Отправить" severity="success" icon="pi pi-upload" onClick={handleBtn} disabled={disabledSave} />
                    <div style={{ height: "50px" }}></div>
                </div>
            </div>
        );
    }),
);

let validRates = {
    counts: null,
    // ratesId: null,
};

const validKeys = (arr, validKeysObj) => {
    const clearKeys = (type) => {
        const obj = Object.assign({}, validKeysObj);
        return obj;
    };

    let isNotValid = true;

    for (let i = 0; i < arr.length; i++) {
        const el = arr[i];
        const objValid = clearKeys(el.cpoType);
        if (el.indefinitely) delete objValid.dateEnd;

        const validKey = Object.entries(objValid).some(([key, val]) => {
            if (Array.isArray(el[key])) {
                return validKeys(el[key], val);
            } else {
                return el[key] == val;
            }
        });
        isNotValid = validKey;
        if (validKey) break;
    }

    return isNotValid;
};
export default ActivateFlexible;
